export default "__VITE_ASSET__Dk9QGXZL__"